import React, { useRef } from "react";
import { BiSolidFilePdf } from "react-icons/bi";
import { FaRegCirclePlay } from "react-icons/fa6";
import { MediaAttachment } from "src/shared/types/src";
import LocalImages from "src/app/static";

type ThumbImageProps = {
  url: string;
  onMediaLoad?: () => void;
  customClass?: string;
};

const ThumbImage: React.FC<ThumbImageProps> = ({
  url,
  onMediaLoad,
  customClass,
}) => {
  const hasReportedRef = useRef(false);
  return url ? (
    <img
      src={url}
      alt="Media Item"
      className={`media-image ${customClass ? customClass : ""}`}
      onLoad={() => {
        if (!hasReportedRef.current) {
          hasReportedRef.current = true;
          onMediaLoad?.();
        }
      }}
      onError={(e) => {
        const target = e.currentTarget;
        target.onerror = null;
        target.src = LocalImages.errorImg;
        if (!hasReportedRef.current) {
          hasReportedRef.current = true;
          onMediaLoad?.();
        }
      }}
    />
  ) : null;
};

type MediaWrapperProps = {
  media: Array<MediaAttachment>;
  onMediaLoad?: () => void;
};

const MediaWrapper: React.FC<MediaWrapperProps> = ({ media, onMediaLoad }) => {
  return (
    <div className="d-flex flex-wrap media-wrapper">
      {media.map((mediaItem, index) => (
        <div className="media-item-wrapper">
          <div className="media-item">
            {mediaItem.media.contentType === "application/pdf" ? (
              <div className="media-overlay">
                <ThumbImage
                  url={mediaItem?.thumb?.url}
                  onMediaLoad={onMediaLoad}
                />
                <BiSolidFilePdf size={40} />
              </div>
            ) : mediaItem.media.contentType === "image" ? (
              <ThumbImage
                url={mediaItem?.thumb?.url}
                onMediaLoad={onMediaLoad}
              />
            ) : mediaItem.media.contentType === "video" ? (
              <>
                <ThumbImage
                  url={LocalImages.videoMediaIcon}
                  onMediaLoad={onMediaLoad}
                  customClass="video-icon"
                />
                {/* <div className="media-overlay">
                  <div className="play-overlay">
                    <FaRegCirclePlay size={40} />
                  </div>
                </div> */}
              </>
            ) : mediaItem.media.contentType === "audio" ? (
              <ThumbImage
                url={LocalImages.audioMediaIcon}
                onMediaLoad={onMediaLoad}
                customClass="video-icon"
              />
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MediaWrapper;
